import React from "react";
import { useAppDispatch } from "../../../../store/hooks";
import { CategoryInterface, setEditId } from "../../../../store/mine_craft/categoriesSlice";
import { destroyCategory, fetchCategories } from "../../../../actions/mine_craft/categoriesActions";

import { message, Popconfirm } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import NavBarThree from "../../../../componets/NavBarThree";
import Summary from "../../../../componets/Summary";
import usePermissions from "../../../../hooks/usePermissions";

const _Summary = ({ category }: { category: CategoryInterface | undefined }) => {
  const dispatch = useAppDispatch();
  const { write_minecraft } = usePermissions();

  function onClickEdit() {
    if (category) {
      dispatch(setEditId(category.id));
    }
  }

  function onClickDestroy() {
    if (category) {
      handleDestroy(category.id).catch(console.error);
    }
  }

  async function handleDestroy(id: any) {
    const resultAction = await dispatch(destroyCategory(id));

    if (destroyCategory.fulfilled.match(resultAction)) {
      dispatch(fetchCategories({ target_id: category?.target_id }));
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyCategory.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  if (!category) {
    return null;
  }

  return (
    <Summary
      title={category.title}
      image={category.image_url}
      options={write_minecraft ? (
        <NavBarThree>
          <NavBarThree.Button onClick={onClickEdit}>
            <EditOutlined /> Edit
          </NavBarThree.Button>

          <NavBarThree.Button>
            <Popconfirm
              placement="bottomRight"
              title='Are you sure to delete this item?'
              onConfirm={onClickDestroy}
              okText="Yes"
              cancelText="No"
            >
              <DeleteOutlined /> Destroy
            </Popconfirm>
          </NavBarThree.Button>
        </NavBarThree>
      ) : undefined}
    />
  )
}

export default _Summary;
